import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'

/**
 * 忘記密碼 Response Schema
 *
 * 1 - 成功
 * 0, null - 失敗
 */
export const forgetPasswordResponseSchema = z.nativeEnum(TrueFalse)

/**
 * 忘記密碼 Response
 *
 * 1 - 成功
 * 0, null - 失敗
 */
export type ForgetPasswordResponse = z.infer<
  typeof forgetPasswordResponseSchema
>
